import { cellText } from '@/lib/daily-reports/cells';

import {
  columnIndex,
  isDescriptionFrHeader,
  isEnglishDescriptionHeader,
} from './headers';

export function catalogFields(
  header: unknown[],
  row: unknown[],
): {
  catalog: string;
  upc: string;
  description: string;
  descriptionFr: string;
  netPrice: string;
} {
  return {
    catalog: cellText(row[columnIndex(header, 'CATALOGUE')]),
    upc: cellText(row[columnIndex(header, 'UPC')]),
    description: cellText(
      row[header.findIndex((cell) => isEnglishDescriptionHeader(cell))],
    ),
    descriptionFr: cellText(
      row[header.findIndex((cell) => isDescriptionFrHeader(cell))],
    ),
    netPrice: cellText(row[columnIndex(header, 'NET PRICE')]),
  };
}
